import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Register.css';
import '../../globalcss.css';
import * as actioncreators from '../../redux/action';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import Loading from 'react-loading-bar';
import { NavLink, withRouter } from 'react-router-dom';
import 'react-loading-bar/dist/index.css';
import { Row, Col, Button, Form, Input, Select } from 'antd';

const Option = Select.Option;
const FormItem = Form.Item;
class Register extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            type:'',
            OSName: navigator.appVersion,
        }
        if (this.props.loggeduserDetails.name) {
            this.props.history.push('/home');
        }
    }

    // register cancel function
    handleCancel = (e) => {
        if (typeof this.props.handleCancel === 'function') {
            this.props.handleCancel();
        }
    }
    // select input function
    handleSelectChange = (value) => {
        console.log(value);
        if (value == 'Business') {
            this.setState({ type: value })
        }
        else {
            this.setState({ type: '' })
        }
    }

    // ADD PROJECT FUNCTION 
    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.props.location);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ show: true });
                console.log('Received values of form: ', values);
                let data = {
                    name: values.name,
                    profileName: values.alias,
                    password: values.password,
                    phoneNumber: values.phone,
                    email: values.email,
                    address: values.address,
                    zipcode: values.zip,
                    type: values.type,
                    businessname:values.businessname,
                    deviceInfo: [
                        {
                            platform: "Web",
                            "model": navigator.appCodeName,
                            "os": this.state.OSName,
                            "deviceId": navigator.productSub
                        }
                    ]
                }

                console.log("create =================", data)
                this.props.actions.register(data, this.props.history)  //CREATE NEW PROJECT
            }
        });
        this.props.form.setFieldsValue({
            ['name']: '',
            ['alias']: '',
            ['password']: '',
            ['profileName']: '',
            ['phone']: '',
            ['email']: '',
            ['address']: '',
            ['zip']: '',
            ['type']: '',
            ['businessname']: ''
        })
    }

    componentDidMount() {
        console.log(navigator)
        console.log("jgnvjhwecfrdfv", this.props.history);
        this.props.actions.userdetails(localStorage.getItem('session'));
        if (navigator.appVersion.indexOf("Win") != -1) this.setState({ OSName: "Windows" });
        if (navigator.appVersion.indexOf("Mac") != -1) this.setState({ OSName: "MacOS" });
        if (navigator.appVersion.indexOf("X11") != -1) this.setState({ OSName: "UNIX" });
        if (navigator.appVersion.indexOf("Linux") != -1) this.setState({ OSName: "Linux" });
     
     
        // function to scrollto top
        // aradhana

        window.scrollTo(0, 0)
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="loginsec">
                <Loading
                    show={this.state.show}
                    color="red"
                    showSpinner={false}
                />

                {/* login us start */}
                <div className="loginsection">
                    <Row type="flex" justify="center">
                        <Col lg={{ span: 24 }} xs={{ span: 22 }}>
                            <div className="loginForm">
                                <Form onSubmit={(e) => { this.handleSubmit(e); this.handleCancel(); }}>
                                    <Row type="flex" justify="space-around">
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('name', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Name" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('alias', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Alias Name" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('email', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Email Address" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('password', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input type="password" placeholder="Password" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('phone', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Phone Number" type="number" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('address', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Address" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>

                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('type', {
                                                    rules: [{ required: false, message: 'Please enter  Category!' }]
                                                })(
                                                    <Select
                                                        autoComplete="off"
                                                        placeholder="Type"
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        <Option value="Individual">Individual</Option>
                                                        <Option value="Business">Business</Option>
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </Col>

                                        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
                                            <FormItem className="emailcont">
                                                {getFieldDecorator('zip', {
                                                    rules: [{ required: true, message: 'Please input your Name!' }],
                                                })(
                                                    <Input placeholder="Zip Code" autoComplete="Off" />
                                                )}
                                            </FormItem>
                                        </Col>
                                        {(this.state.type == 'Business') ?
                                            <Col lg={{ span: 23 }} xs={{ span: 24 }}>
                                                <FormItem className="emailcont">
                                                    {getFieldDecorator('businessname', {
                                                        rules: [{ required: false, message: 'Please input your Business Name!' }],
                                                    })(
                                                        <Input placeholder="Business Name" autoComplete="Off" />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            : ''}
                                        <h5 className="trems">By continuing, you agree to our <NavLink to="/contact"> Terms of use and Privacy Policy</NavLink></h5>

                                        <FormItem className="text-center">
                                            <Button

                                                type="primary"
                                                htmlType="submit">
                                                Sign Up
                                                    </Button>
                                        </FormItem>

                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div >
        );
    }
}
const mapStateToProps = (state) => {
    return state
}
function mapDispatchToProps(dispatch, state) {
    return ({
        actions: bindActionCreators(actioncreators, dispatch)
    })
}
const WrappedRegister = Form.create()(Register);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedRegister));


// WEBPACK FOOTER //
// ./src/Component/Register/Register.js